import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'
import create from 'zustand'

interface ApproveReserveOrderLinkModalState {
  proposalId: string
  isModalOpen: boolean
  setModalIsOpen: (open: boolean) => void
  setProposalId: (proposalId: string) => void
}

const useStoreBase = create<ApproveReserveOrderLinkModalState>()((set) => ({
  proposalId: '',
  isModalOpen: false,
  setModalIsOpen: (isModalOpen: boolean) => set(() => ({ isModalOpen })),
  setProposalId: (proposalId: string) => set(() => ({ proposalId }))
}))

export const useApproveReserveOrderLinkModalStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase &
  ZustandHookSelectors<ApproveReserveOrderLinkModalState>
